export default {
  component: {
    federatedLoginError: {
      heading: 'Authentication failed',
      content:
        'We were unable to log in you. Please try again later and if the issue continues please contact our support.',
    },

    accountMenu: {
      myAccount: 'My account',
      billing: 'Billing',
      userManagement: 'User management',
      organisationProfile: 'Organisation settings',
      statistics: 'Statistics',
      videos: 'Video library',
    },

    adminNavigationBar: {
      dashboard: 'Dashboard',
      backToMainMenu: 'Back to main menu',
      noTutorial: 'This page does not have a tutorial yet',
    },

    actionLog: {
      noAction: 'No actions',
      show: 'Show content',
      hide: 'Hide content',
      action: {
        comment: 'commented application',
        invite: 'invited to interview',
        schedulingInvite: 'sent candidate a scheduling invite',
        reScheduled: 'rescheduled the interview',
        addedCandidateToRound: 'added candidate to interview round',
        selectedInterviewTime: 'Candidate selected interview time',
        reInvite: 'resent invitation to candidate',
        smsInvite: 'invited to interview with SMS',
        smsReInvite: 'resent invitation to candidate with SMS',
        videoResponse: 'Candidate answered to videoquestion',
        message: 'sent email',
        personalInterviewMessage: 'sent invitation to scheduled meeting',
        smsMessage: 'sent SMS message',
        PersonalInterviewInvitationRemoved:
          'deleted previous invitation to scheduled meeting',
        videoMessage: 'sent video message',
        applicationCreatedByAdmin: 'added this candidate',
        stageChanged: placeholderKeys =>
          `moved candidate to stage ${placeholderKeys.stage}`,
        answeredToInterview: placeholder =>
          `Candidate answered to interview ${placeholder.opening}`,
        applicationCreated: 'Application created',
        applicationUpdated: 'Application updated',
        candidateUpdated: 'Candidate updated',
        introductionToOne: placeholders =>
          `Candidate was introduced to ${placeholders.introducee}`,
        introductionToMany: placeholders =>
          `Candidate was introduced to ${placeholders.introduceeCount} recipients`,
        calendarEventCreated: placeholders =>
          `Candidate booked a meeting: ${placeholders.eventStartTime}`,
        addRating: 'added rating',
        deleteRating: 'deleted their rating',
        withdrew: 'Candidate withdrew from the process.',
        resetQuestionResponse: "Deleted candidate's response",
        joinedLiveInterview: 'Candidate joined the interview',
        evaluated: 'evaluated the candidate',
      },
      videoLink: {
        linkText: 'Show content',
      },
    },

    additionalFormFields: {
      title: 'Additional form fields',
      description: context =>
        context === 'interview'
          ? 'Additional fields cannot be deleted after invitations are sent.'
          : 'Additional fields cannot be deleted if the position has applications.',
      add: 'Add a new form field',
      addOption: 'Add',
      delete: 'Delete',
      done: 'Done',
      cancel: 'Cancel',
      edit: 'Edit',
      required: 'Required',
      optional: 'Optional',
      notAsked: 'Not asked',
      shortText: 'Short text',
      longText: 'Long text',
      singleSelect: 'Single selection',
      multiSelect: 'Multiselection',
      fieldLabelPlaceholder: 'Field label for candidates',
      fieldNamePlaceholder: 'Field name for recruiters',
      addLabel: 'Add label',
      addName: 'Add name',
      typeLabel: 'Field type',
      nameLabel: 'Field label',
      optionLabel: 'Field options',
      settingsLabel: 'Form settings',
      reorder: 'Reorder fields',
      stopReordering: 'Stop reordering fields',
      optionPlaceholder: 'Add an option',
      optionError: 'Option already exists',
    },

    addPublicQuestions: {
      title: 'Video question',
      description:
        'Say hello to your candidates and add application phase video question here.',
    },

    addQuestions: {
      edit: {
        start: 'Reorder questions',
        stop: 'Stop reordering questions',
      },
      placeholder: isMobile =>
        isMobile
          ? 'Click to upload or record a question'
          : 'Click to record a question',
      textQuestionPlaceholder: 'Click to write a question',
      videoPlaceholder: isMobile =>
        isMobile
          ? 'Click to upload or record a new video'
          : 'Click to record a new video',
      library: 'Select from library',
      text: 'Text question',
      record: 'Record',
      upload: 'Upload',
      answerable: 'Question can be answered',
      required: 'Answer is required',
      questionPlaceholder: 'Write your question here',
      evaluationCriteriaLabel: 'Evaluation criteria',
      evaluationCriteriaPlaceholder: 'Enter question evaluation criteria here',
      answerTimeLabel: 'Answer time',
      takeLimitLabel: 'Number of takes',
      preparationTimeLabel: 'Preparation time',
      cancel: 'Cancel',
      add: 'Add',
      unlimitedLabel: 'Unlimited',
    },

    addVideo: {
      title: 'Employer video',
      description:
        'Promote your company culture and enhance employer branding by adding an employer video to the job ad.',
    },

    adminCoverPhoto: {
      welcome: name => `Welcome, ${name}!`,
      photo: 'Add background image',
      removePhoto: 'Remove background image',
    },

    adminFooter: {
      licenseLink:
        'https://www.recright.com/en/user-agreement/RecRight-license_agreement.pdf',
      privacyPolicyLink: 'https://get.recright.com/privacy-policy',
      termsLink:
        'https://get.recright.com/recright-terms-and-conditions-recruiter',
      accessibilityReportLink:
        'https://websitemedia.recright.com/wp-content/uploads/2024/11/06112306/accessibility_report.pdf',
    },

    applicationFormSetup: {
      title: 'Application form setup',
      notAsked: 'Not asked',
      optional: 'Optional',
      required: 'Required',
      name: 'Name',
      coverLetter: 'Cover letter',
      email: 'Email',
      phoneNumber: 'Phone number',
      city: 'City',
      attachments: 'Attachments',
      links: 'Links',
      questions: 'Video question',
      attachmentsDescription: 'Description for attachments',
    },

    billingPlanSelector: {
      select: 'Select',
      removeSelection: 'Remove selection',
      month: ' /month',
      'recright-ats': 'Recright ATS',
      'recright-video-interview': 'Recright Video Interview',
      'recright-essential': 'Recright Essential',
      'recright-pro': 'Recright Pro',
      'recright-premium': 'Recright Premium',
      'single-recruitment': 'Single recruitment',
      'recright-easy': 'Easy',
      'recright-pro2': 'Pro',
      customPlan: 'Recright Custom plan',
      plans: {
        'recright-easy': {
          info: '10 - 20 positions per year for small to midsized companies.',
          info2: '10 positions included, with the option to add 5 or 10 more.',
          features: [
            'Over 50 positions/year',
            'Unlimited user seats',
            'User administration',
            'Complimentary recorded video training',
            'Branding',
            'Customer support',
          ],
          unitType: '/month',
        },
        'recright-pro2': {
          info: 'For regularly recruiting companies.',
          info2: 'Everything from single recruitment and:',
          features: [
            '10 video recruitments / year',
            'Max 50 candidates / video recruitment',
            'Unlimited user seats',
            'User administration',
            'Customer support',
            'Basic branding',
            'Customer Success',
            'Statistics',
          ],
          unitType: '/month',
        },
        'recright-ats': {
          features: [
            'Recruitment tool',
            'Unlimited job ads',
            'Employer branding video',
            'In-application video question',
            'Candidate screening',
            'Candidate communication',
            'Team engagement',
            'Candidate database',
          ],
          unitType: '/month',
        },
        'recright-video-interview': {
          features: [
            'Recright ATS included',
            'Recorded video interviews',
            'Multiple video questions',
            'Reporting tool',
            'Online training',
            '15 video interview positions per year',
          ],
          unitType: '/month',
        },
        'recright-custom': {
          features: [
            'Volume-based pricing',
            'Dedicated account manager',
            'Integration to your ATS',
            'Live video interview',
          ],
          unitType: '/month',
        },
        'recright-essential': {
          features: [
            '15 positions/year',
            'Max 50 candidates/position',
            'Unlimited users',
            'Complimentary recorded video training',
          ],
          unitType: '/month',
        },
        'recright-pro': {
          features: [
            '30 positions/year',
            'Max 50 candidates/position',
            'Unlimited users',
            'Complimentary recorded video training',
            'Best practices training',
            'Enhanced branding: logo, banner, fonts, colors',
            'Candidate Feedback Pulse',
            'Reporting',
            'Dedicated Account Manager',
            'User administration',
          ],
          unitType: '/month',
        },
        'recright-premium': {
          features: [
            'Over 50 positions/year',
            'Unlimited users',
            'Best practices training',
            'Enhanced branding: logo, banner, fonts, colors',
            'Candidate Feedback Pulse',
            'Reporting',
            'Dedicated Account Manager',
            'User administration',
            'ATS integration',
            'Live interview',
            'Active Directory integration',
          ],
          unitType: '/month',
        },
        'single-recruitment': {
          info: 'Perfect to try the full power of pre-recorded interviews',
          features: [
            'All features included',
            'Includes a single job ad and a video interview',
            'valid for 60 days \n\n after the job ad or video interview have been created',
          ],
          unitType: '/recruitment',
        },
      },
    },

    branding: {
      headerFont: 'Header Font',
      bodyFont: 'Body Font',
      backgroundColor: 'Background color',
      textColor: 'Text color',
      brandColor: 'Brand color',
      buttonTextColor: 'Button text color',
      headerTextColor: 'Header text color',
    },

    candidateCard: {
      noStatus: 'No status set',
      lastSeen: time => `Last seen ${time}.`,
      notVisited: 'Has not visited on interview.',
    },

    comments: {
      placeholder: 'Add a new comment',
      submit: 'Add',
      delete: 'Delete',
      showComments: "Show others' comments",
      hideComments: "Hide others' comments",
    },

    competencyList: {
      duplicateError: 'Competency with that name already exists',
      defaultText:
        'If you are unsure what competencies to use, we have defined some good defaults to start with.',
      defaultLinkText: 'Get the defaults',
      addCompetency: 'Add competency',
    },

    chooseLicenseLink: {
      title: 'Choose license',
    },

    currentFilters: {
      currentFilters: 'Current filters:',
    },

    emailForm: {
      emailLabel: 'Email',
      defaultButtonText: 'Send',
    },

    filterToggler: {
      hideFilters: 'Hide filters',
      showFilters: 'Show filters',
    },

    hashtags: {
      placeholder: 'Add a tag',
      delete: 'Delete',
    },

    imageInput: {
      errors: {
        format: 'File is not a image.',
        size: 'Image file is too large, maximum size for the file is 4 MB.',
      },
    },

    emailTemplateForm: {
      subjectPlaceholder: 'Subject',
      messagePlaceholder: 'Message',
      namePlaceholder: 'Name',
      namePlaceholder2:
        'If left blank, uses current user signature or name when sending invites.',
      templateNameLabel: 'Template name',
      titleDisclaimer:
        '[INTERVIEW TITLE] will be replaced with the interview title when sending the invites.',
      titleDisclaimerJob:
        '[JOB TITLE] will be replaced with the job title when the message is sent.',
      confirmLanguageChange:
        'Are you sure you want to change the language? All your unsaved changes will be lost.',
      formatInfo:
        'You can add bolded text, cursive text or links with special formatting:',
      cursive: '_Cursive_',
      bolded: '*Bolded*',
      link: '[http://example.com|Link text]',
      greetingLabel: 'Greeting',
      greetingPlaceholder:
        'Greeting that is shown at the end of the message before the signature name.',
      greetingPlaceholder2: defaultGreeting =>
        `If left blank, default greeting ${defaultGreeting} will be used in the sent message.`,
      getDefaultGreeting: 'Get default greeting',
    },

    liveEvaluation: {
      interviewTabLabel: 'Interview',
      evaluationTabLabel: 'Evaluation',
      interviewNotesLabel: 'Interview notes',
      evaluationNotesLabel: 'Evaluation notes',
      thankYouLabel: 'Thank you!',
      evaluationSavedLabel: 'We have saved your evaluation of the candidate.',
      evaluatorLabel: 'Evaluator',
      evaluatorCount: count => (count === 1 ? '1 has evaluated' : `${count} have evaluated`),
      interviewersLabel: 'Interviewers',
      transcriptLoadingLabel: 'Transcript loading',
      recordingLabel: 'Interview recording',
      evaluationNotesPlaceholder: stepTitle => `Notes for ${stepTitle}`,
      goToAILabel: 'Jump to AI notes',
      goBackLabel: 'Go back up',
      AISummaryLabel: 'AI Summary',
      AINotesLabel: 'AI Notes',
      AIInsightsLabel: 'AI Insights',
      aiAssistant: 'AI Assistant',
      average: 'Average',
      continueLaterLabel: 'Continue later',
      transcriptButtonText: 'Interview transcript',
      transcriptionError: 'Error fetching transcript',
      finishAndSubmitLabel: 'Finish the evaluation',
      averageForAllSections: 'Average for the interview',
      continueLaterText: title =>
        `We sent you an email with the link so you can continue the candidate evaluation in the interview ${title} later.`,
      continueLaterNoTitleText:
        'We sent you an email with the link so you can continue the candidate evaluation in the interview later.',
      closeEvaluation: 'Close',
      continueEvaluation: 'Continue evaluation',
      confirmationTitle: 'Finish the evaluation?',
      confirmationMessage:
        'Are you sure you want to finish the evaluation? You will not be able to make further changes after finishing.',
      previousStepButton: 'Go to previous',
      nextStepButton: 'Go to next',
      selectAtLeastOneEvaluator: 'Please select at least one evaluator.',
      interviewInsights: 'Interview insights',
    },

    interviewFormSetup: {
      title: 'Interview form setup',
      notAsked: 'Not asked',
      optional: 'Optional',
      required: 'Required',
      name: 'Name',
      email: 'Email',
      phoneNumber: 'Phone number',
      city: 'City',
      attachments: 'Attachments',
      links: 'Links',
      attachmentsDescription: 'Description for attachments',
    },

    interviewRow: {
      invites: 'Invites',
      responses: 'Responses',
      endTime: 'End date',
      createdAt: 'Creation date',
      timedTitle: 'Timed video interview',
      newVideos: 'New responses',
    },

    interviewGuideRow: {
      createdAt: 'Creation date',
      owner: 'Owner',
      language: 'Language',
    },

    interviewRoundRow: {
      createdAt: 'Creation date',
      owner: 'Owner',
      language: 'Language',
      endTime: 'Open until',
      status: 'Status',
    },

    interviewGuideStep: {
      noSteps: 'No sections added yet.',
      reorder: 'Reorder sections',
      titleLabel: 'Section title',
      titlePlaceholder: 'Add a title for the section',
      interviewContentPlaceholder: 'Content for the section during interview',
      evaluationContentPlaceholder: 'Content for the section after interview',
      interviewTabLabel: 'Questions',
      evaluationTabLabel: 'Evaluation',
      stepTimeLabel: 'Section time estimate (min)',
      stopReordering: 'Stop reordering sections',
      delete: 'Delete section',
      add: 'Add new section',
    },

    introduction: {
      batchIntroduction: count => `Introduced to ${count} recipients`,
    },

    jobAdRow: {
      newApplications: 'Unseen',
      applications: 'Applications',
      publishTime: 'Publish date',
      endTime: 'Open until',
    },

    positionStatus: {
      open: date => (date ? `until ${date}` : ''),
      hidden: date => (date ? `until ${date}` : ''),
      filled: () => 'status: Filled',
      cancelled: () => 'status: Cancelled',
      closed: () => 'status: Closed',
      draft: () => 'status: Closed (draft)',
      unpublished: () => 'status: Unpublished',
      publishTime: 'Publish date',
    },

    jobAdTeaser: {
      add: 'Add new candidate',
      preview: 'Preview the job ad here',
      noApplications: 'No applications yet.',
      placeholder: {
        first:
          'You can boost and market your job ad with direct links to your job portal',
        second: 'or you can market this particular job with direct link',
        third:
          "And don't forget that all of these are only one button away in the title bar above.",
      },
    },

    list: {
      total: count => `Total: ${count}`,
      selectAll: 'Select all',
      resetSelection: count =>
        count > 0 ? `Reset selection (${count})` : 'Reset selection',
    },

    liveRow: {
      finished: 'Finished',
      coming: 'Upcoming',
      active: 'Ongoing',
      titleFallback: 'Live interview',
      startTime: 'Start time',
      interviewers: 'Interviewers',
      candidates: 'Candidates',
      status: 'Status',
    },

    loginForm: {
      email: 'Email',
      password: 'Password',
      submit: 'Log in to the service',
      changePasswordInfo:
        'Password changed successfully! Log in with your new password.',
      error: {
        email: {
          isRequired: 'Please provide your email address.',
          isEmail: value => (value ? `${value} is not a valid email.` : ''),
        },
        password: {
          isRequired: 'Please provide a password.',
        },
        login: {
          incorrect: 'The email or password you provided was incorrect.',
          deactivated:
            "User account has been deactivated. Please reach out to your organisation's admin at Recright.",
          tries:
            'To protect your security we are limiting the rate of retrying passwords. Try again in a moment or reset your password.',
        },
      },
    },

    logoUpload: {
      logoTitle: 'Organisation logo here',
      removeLogo: 'Remove logo',
      addLogo: 'Select logo',
    },

    modalAccountType: {
      title: 'Change account type?',
      confirm: 'Change',
      cancel: 'Cancel',
    },

    modalApplicationAllInvited: {
      title: 'Invite candidates',
      description:
        'All the selected candidates have already been invited to the interview.',
    },

    modalApplicationIntroduce: {
      title: 'Introduce candidates',
      description: "Enter the introduction recipient's email addresses below",
      titlePlaceholder: 'Title',
      contentPlaceholder: 'Message content',
      emailsPlaceholder: 'Recipient emails',
      namePlaceholder: 'Name',
      cancel: 'Cancel',
      sendIntroductions: 'Send introductions',
    },

    modalApplicationInvite: {
      title: 'Invite the candidate to the next recruitment stage',
      description:
        'Proceed with the selected candidate and select the desired action below.',
      createNew: 'Create new video interview',
      videoInterviewDescription:
        'Invite a candidate to a video interview and meet the real person behind the resume!',
      error: {
        selectInterview: 'Please select interview.',
      },
      cancel: 'Cancel',
      close: 'Close',
      continue: 'Continue',
    },

    modalApplicationReInvite: {
      title: 'Resend invitation to applicant',
      description:
        'Choose the interview you want to reinvite the applicant to.',
      info: 'You cannot send invitations to interviews that are closed.',
      cancel: 'Cancel',
      submit: 'Resend invitation',
    },

    modalApplicationMessage: {
      title: 'Send message to selected candidates',
      description: 'What kind of message do you want to send?',
      email: 'Send email',
      videoMessage: 'Send video message',
      close: 'Close',
      cancel: 'Cancel',
      continue: 'Continue',
      sendEmail: 'Send message',
      emailTitle: 'Send email to candidates',
      emailDescription: 'Write email to selected candidates',
      videoTitle: 'Add new video',
      titlePlaceholder: 'Title',
      contentPlaceholder: 'Write your message here',
      candidates: 'candidates',
      selectedCandidates: 'Recipients',
      emailSent: 'Email sent!',
      answerable: 'Video can be answered',
      signature: 'Best regards,',
    },

    modalAtsTeaser: {
      title: 'Publish open positions and manage the recruitment process',
      content:
        'Choose the information you want to ask from the candidates and publish your open position. We host your career page and you can easily share the link anywhere. Your employer image improves with efficient candidate communication.',
      cancel: 'Cancel',
      confirm: 'Yes, contact me',
      greetings: 'Message sent successfully.',
    },

    modalFeedbackPulseTeaser: {
      title:
        'Curious to see how your candidates rated the recruitment process?',
      content:
        'At the end of every recruitment process, candidates have the opportunity to rate their experience. Your overall rating is based on an average of all the collected feedback.',
      cancel: 'Cancel',
      confirm: 'Yes, contact me',
      greetings: 'Message sent successfully.',
    },

    modalCandidateMessage: {
      title: count =>
        count > 1
          ? 'Send message to selected candidates'
          : 'Send message to the candidate',
      description: 'What kind of message do you want to send?',
      recipients: count => `Message will be sent to ${count} recipients`,
      email: 'Send email',
      videoMessage: 'Send video message',
      library: 'Select from library',
      close: 'Close',
      cancel: 'Cancel',
      continue: 'Continue',
      sendEmail: 'Send message',
      resendInvitation: 'Resend invitation with email',
      resendInvitationSms: 'Resend invitation with SMS',
      emailTitle: count =>
        count > 1 ? 'Send email to candidates' : 'Send email to the candidate',
      emailDescription: 'Write email to selected candidates',
      libraryTitle: count =>
        count > 1 ? 'Send video to candidates' : 'Send video to the candidate',
      videoTitle: 'Add new video',
      titlePlaceholder: 'Title',
      contentPlaceholder: 'Write your message here',
      candidates: 'candidates',
      selectedCandidates: 'Recipients',
      emailSent: candidates => `${candidates} emails sent!`,
      answerable: 'Video can be answered',
      successMessage: candidates => `${candidates} video messages sent!`,
      scheduledInterview: 'Send Scheduled meeting invitation',
      scheduledInterviewDescription:
        'Let the candidate schedule a meeting with you based on your listed availability.',
      reScheduledInterview: 'Reschedule Meeting',
      reScheduledInterviewDescription:
        'Reschedule a meeting with a candidate. Please note that previous meeting invitations will be cancelled',
      sms: 'Send SMS message',
      record: 'Record',
      upload: 'Upload',
      required: 'Fields marked with * asterisk are mandatory',
      tooManyRecipients: count => `Too many recipients selected. Maximum is ${count}.`,
      tooLongMessage:
        'The message is too long. Check the character counter. Note: Some special characters reduce the maximum message length.',
    },

    modalEditIntroduceBatches: {
      title: 'Introductions',
      description:
        "Here you can manage your position's introductions. You can extend the introduction link expiration date, remove recipients or remove entire introduction groups from the position.",
      noBatches: 'No introductions.',
      descriptionWithCount: (candidateNames) =>
        `Introduced ${candidateNames} and %COUNT_LINK% other to following recipients:`,
      descriptionWithoutCount: candidateNames =>
        `Introduced ${candidateNames} to following recipients:`,
      email: 'Email',
      expires: 'Expires',
      actions: 'Actions',
      visited: 'Visited',
      extendLinkText: 'Extend',
      extendTo: date => `Extend to ${date}`,
      close: 'Close',
      deleteBatch: 'Delete batch',
      deleteBatchWarning:
        'Are you sure you want to remove the introduce batch?',
      maxExpirationDate:
        'The expiration date can be a maximum of 10 days from today.',
      extendedMessage: newExpirationDate =>
        `Recipient's introduction link expiration date extended to ${newExpirationDate}!`,
      url: 'URL',
      introductionLink: 'Link',
    },

    modalEditEmailSettings: {
      customReplyToTitle: 'Invitation message sender information',
      customReplyToSubtitle:
        'The sender name and reply address for the interview invitations. If left empty, the name and email of the user sending the invites are used.',
      customReplyToEmail: 'Reply email for invitations',
      customReplyToName: 'Sender name for invitations',
      saveSuccess: 'Settings saved successfully!',
    },

    modalEditInvitationMessage: {
      title: 'Edit invitation message saved to the interview',
      info: 'Select the interview you want to edit',
      close: 'Close',
      saveTemplate: "Save as interview's invite template",
      templateSaved:
        'The message was now saved as a template for the interview.',
      templateOptionsLabel: 'Select template',
      interviewRound: {
        title: 'Edit the invitation message for this interview round',
        submitButtonText: 'Save interview round invitation template',
        templateSaved: 'The interview round invitation template was saved',
      },
    },

    modalEditStages: {
      title: 'Edit recruitment stages',
      info: 'You can edit, add, delete and rearrange custom stages. Note that it is not possible to remove a stage if there are candidates in the stage.',
      addNewStage: 'Add a new custom stage',
      removeDisabled:
        'Removing is disabled when there are candidates in the stage.',
      error: 'Stage already exists.',
      done: 'Done',
      save: 'Save',
      close: 'Close',
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },

    modalHidePositionsFromUser: {
      modalHeader: 'Hidden positions',
      modalDescription: name =>
        `Control which positions the user ${name} will see.`,
      hiddenFrom: name => `Positions hidden from user ${name}`,
      noResults: 'No results',
      noPositions: 'No positions',
      jobAdLabel: 'Job ad',
      interviewLabel: 'Video interview',
      total: total => `${total} positions total`,
      close: 'Close',
      hide: 'Hide',
      remove: 'Remove',
      searchInfo: 'Browse for positions to hide',
      searchPlaceholder: 'Search by position title or location',
      labels: {
        title: 'Title',
        location: 'Location',
        time: 'Creation date',
        actions: 'Actions',
      },
    },

    modalRemoveUserFromOrganisation: {
      modalHeader: 'Removing user from this organisation',
      modalDescription: name =>
        `The user ${name} is an external user and will be only removed from this organisation. Despite this removal, they will retain access to other organisations within Recright.`,
      modalExplanation: name =>
        `Consequently, the user will no longer have access to positions within this organisation. You will inherit access to positions for which ${name} was the sole recruiter.`,
      adminInRecruitmentTeam: name =>
        `Positions in which the user ${name} was a part of the Recruitment team:`,
      noResults: 'No results',
      noPositions: 'No positions',
      jobAdLabel: 'Job ad',
      interviewLabel: 'Video interview',
      total: total => `${total} positions total`,
      close: 'Close',
      remove: 'Remove from organisation',
      removeUserConfirmMessage: 'Remove user',
      removeUserConfirmContent:
        'Are you sure you want to remove user from this organisation?',
      labels: {
        title: 'Title',
        time: 'Creation date',
        creator: 'New position owner',
      },
      otherAdmin: 'Other admin in recruitment team',
    },

    modalInterviewRoundSelectInviteType: {
      title: 'Select scheduling type',
      subtitle: 'Choose if you want to select the time for the interview yourself or if you want to let the candidate select the time.',
      regularTitle: 'Regular',
      regularDescription: 'The time of the interview is chosen by you.',
      scheduledTitle: 'Scheduled',
      scheduledDescription:
        "The time of the live interview is chosen by the candidate based on the interviewers' availability.",
      cancel: 'Cancel',
      continue: 'Continue',
    },

    modalInterviewRoundInvite: {
      nameEmailLabel: 'Name/Email',
      startTimeLabel: 'Interview start time',
      title: 'Schedule interview',
      submit: 'Invite candidates',
      selectedCandidates: 'Selected candidates',
      savedTemplate: 'Saved invitation message template',
      templateChangedInfo:
        'You have edited the invitation message. This change will be sent to this batch of recipients, but will not be saved to the interview round invitation template.',
      saveTemplate: "Save as interview round's invite template",
      templateSaved:
        'The message was now saved as a template for this interview round.',
    },

    interviewRoundInviteModalContent: {
      subjectPlaceholder: 'Subject',
      messagePlaceholder: 'Message',
      namePlaceholder: 'Name',
    },

    modalReschedule: {
      title: 'Reschedule interview',
      submit: 'Send message',
      rescheduleConfirmBody: 'Are you sure you want to reschedule this interview?',
    },

    modalPersonStage: {
      new: 'New',
      hired: 'Hired',
      proceed: 'Proceed',
      personalinterview: 'Personal interview',
      withdrawn: 'Withdrawn',
      scheduledinterview: 'Scheduled meeting',
      rejected: 'Rejected',
      videointerviewed: 'Video interview',
      change: 'Move candidates to another stage',
      info: 'move the selected candidates to another stage. This information is not visible to the candidates.',
      done: 'Move',
      cancel: 'Cancel',
      changed: 'Great!',
      changedInfo: stage =>
        `Now that you have moved these candidates to the stage "${stage}" let them know about it! \n\n Send them an email or video message.`,
      close: 'Close',
      changeSingle: 'Move the candidate to another stage',
      infoSingle:
        'Move the candidate to another stage. This information is not visible to the candidate.',
      changedInfoSingle: stage =>
        `Now that you have moved the candidate to the stage "${stage}" let them know about it! \n\n Send them an email or video message.`,
      reopenProcessConfirmPlural:
        'Are you sure you want to move these candidates away from the "Withdrawn" stage and return them back to the recruitment process? After confirming, the candidates will again be able to answer the interview if they have not yet completed.',
      withdrawConfirmPlural:
        'Are you sure you want to withdraw these candidates from the recruitment process? If withdrawn, the candidates are no longer able to access the interview.',
    },

    modalInterviewAdd: {
      title: 'Create new interview',
      description: 'Choose the type of interview you want to create',
      friendlyTitle: 'Video interview',
      friendlyDescription:
        'Candidates can record as many takes as they like and there is no time limit in each take.',
      timedTitle: 'Timed video interview',
      timedDescription:
        'Candidates record their responses to the interview questions in a limited and preset time frame. You can set the time to both response and preparation for each question.',
      cancel: 'Cancel',
      continue: 'Continue',
    },

    modalLiveInterviewAdd: {
      title: 'Create new live interview',
      description: 'Choose the type of live interview you want to create.',
      basicTitle: 'Normal live interview',
      basicDescription: 'The time of the live interview is chosen by you.',
      scheduledTitle: 'Scheduled live interview',
      scheduledDescription:
        'The time of the live interview is chosen by the candidate based on your availability.',
      cancel: 'Cancel',
      continue: 'Continue',
    },

    modalInterviewPublish: {
      modalTitle: 'Publishing settings',
      publicTitle: 'Public interview',
      publicDescription:
        'This interview has a public page with an address you can share in your job adverts and your company homepage. Anyone interested in the position can see your questions and then decide to participate. You will receive the usual notification when answers start arriving.',
      publishButton: 'Create public link',
      unPublishButton: 'Remove public link',
      title: 'Embedded interview',
      description:
        'A Single-question interview can be embedded seamlessly into a job announcement or your company homepage. Candidates input their email, record one video answer and provide a link to their LinkedIn profile as additional information (optional).',
      descriptionMultiple:
        'Seamlessly integrate a video interview into your job announcement or company homepage. Candidates simply input their email, record video responses, and have the option to include a link to their LinkedIn profile for additional information.',
      embedNotification:
        "You can't ask other information with an embedded question.",
      embedButton: 'Create embed code',
      unEmbedButton: 'Remove embed',
      close: 'Close',
      oneError:
        'Embedded interview can only have one question. Please remove extra questions to use embedded function.',
      subscriptionNeeded:
        'You need an active subscription to publish your interview.',
    },

    modalIntroduce: {
      title: count =>
        count > 1 ? 'Introduce candidates' : 'Introduce the candidate',
      descriptionFirst:
        'With the introduction feature you are able to introduce selected candidates to colleague or customer.',
      descriptionSecond:
        ' Enter the introduction recipients\'s email adresses below. Select what information you want the recipients to see from the candidate. Recipients will only see the selected information. If you select "Rating" or "Competencies and compatibility" recipients are able to enter their ratings and will also see the average rating.',
      descriptionThird:
        'You also have an option to protect the introductions with a passcode which recipients then have to enter in order to see the introduced candidates.',
      descriptionFourth: days =>
        `The introduction link expires in ${days} days. You can extend the expiration date from the introductions settings. You can find these settings from the "Edit" menu under "Edit introductions".`,
      titlePlaceholder: 'Title',
      contentPlaceholder: 'Message content',
      emailsPlaceholder: 'Recipient emails',
      namePlaceholder: 'Name',
      cancel: 'Cancel',
      sendIntroductions: 'Send introductions',
      selectedCandidates: count =>
        `${count} candidates selected for introduction`,
      successMessage: (candidates, introducees) =>
        `${candidates} candidates introduced to ${introducees} introducees`,
      infoMessage: (candidates, introducees, isInTeam) =>
        `${candidates} candidates introduced to ${introducees} introducees. ${isInTeam} were already in the recruitment team`,
      alreadyInTeam: inTeam =>
        inTeam > 1
          ? 'are already in the recruitment team.'
          : 'is already in the recruitment team.',
      name: 'Name',
      email: 'Email',
      phone: 'Phone number',
      city: 'City',
      coverLetter: 'Cover letter',
      attachments: 'Attachments',
      links: 'Links',
      competencies: 'Competencies and compatibility',
      videoResponses: 'Video answers',
      comments: 'Comments',
      rating: 'Rating',
      informationsHeader: 'Choose what information to introduce',
      messageHeader: 'Introduction message',
      selectAll: 'Select all',
      resetSelection: 'Reset selection',
      usePasscodeText: 'Protect introduction group with a passcode',
      passcode: 'Passcode',
      generatePasscode: 'Generate new passcode',
      copyToClipboard: 'Copy to clipboard',
      copySuccess: 'Passcode copied!',
      close: 'Close',
      introduceLinkButton: 'Create link',
      introduceLink: 'Introduce with a link',
      introduce: 'Introduce',
      formError: 'Error',
      linkCreationError: 'Error creating introduction link',
      link: 'Link',
      aiInsights: 'AI insights',
      transcripts: 'Transcripts',
      continue: 'Continue',
    },

    modalInterviewInvite: {
      senderInfo: 'Invites are sent from invitations@recright.com email address.',
      replyToEmail: 'Reply email for invitations',
      replyToName: 'Sender name for invitations',
      replyToInfo:
        'You can edit the reply email and name in the interview edit page.',
      notAnswerable:
        "You can't invite candidates to closed interview or interview which doesn't have answerable questions.",
      title: 'Invite candidates',
      description: "Enter all the candidates' email addresses.",
      description2:
        'When they reply, you will be notified by email. Note that after you have invited candidates, you cannot add questions anymore.',
      smsDescription:
        'After sending email invitations you can send SMS message to the candidates',
      addressesPlaceholder: "Candidates' email addresses",
      submit: 'Send invites',
      cancel: 'Cancel',
      close: 'Close',
      templateChangedInfo:
        'You have edited the invitation message. This change will be sent to this batch of recipients, but will not be saved to the interview.',
      saveTemplate: "Save as interview's invite template",
      templateSaved:
        'The message was now saved as a template for this interview.',
      inviteInfo: (newInvitees, stage) =>
        `The invitation message will be sent to ${newInvitees} candidate(s) from the selected candidates. All selected candidates will be moved to stage "${stage}".`,
      invitesSent: (success, failed) =>
        failed > 0
          ? `${success} invitations sent and ${failed} was already invited.`
          : `${success} invitations sent.`,
      subscriptionNeeded:
        'You need an active subscription to invite candidates.',
      templateOptionsLabel: 'Select template',
      rrTemplateOptionLabel: 'Recright default template',
      interviewTemplateOptionLabel: 'Invitation message saved to this interview',
      interviewRoundTemplateOptionLabel: 'Invitation message saved to this interview round',

    },

    modalInterviewInviteSms: {
      title: 'Invites sent successfully',
      description: count => `${count} invitations sent successfully`,
      description2:
        'Do you also want to send an SMS message to the invited candidates?',
    },

    modalSmsMessage: {
      title: 'Send SMS message',
      invitationTitle: 'Send invitation with SMS',
      resendInvitationTitle: 'Resend invitation with SMS',
      description: count => `Message will be sent to ${count} recipients`,
      missingInvitationDescription: count =>
        `${count} recipients are missing invitation. Please write the invitation message below.`,
      missingPhone: count =>
        `${count} recipients are missing a valid mobile phone number.`,
      missingPhone2: 'Please add the mobile phone numbers to the fields below.',
      successMessage: count => `${count} SMS messages sent successfully.`,
      partialSuccessMessage: (successCount, failedCount) =>
        `${successCount} SMS messages sent successfully. Failed to deliver ${failedCount} SMS messages.`,
      failedMessage: 'Failed to send any SMS message to recipients',
      phonePlaceholder: 'Phone number',
      recipientsNotFound:
        'An unexpected error occurred. Please try again later and if the problem persists please contact our support.',
    },

    modalInterviewStatus: {
      change: 'Change interview status',
      changed: 'Interview status changed',
      changeRoundStatus: 'Change interview round status',
      roundStatusChanged: 'Interview round status changed',
      changedInfo:
        'Interview status changed. Remember to inform candidates about decisions!',
      info: 'Select the new status for the interview.',
      open: 'Open',
      closed: 'Closed',
      done: 'Done',
      close: 'Close',
      endTimeInPast: model => model === 'interview' ? 
        'This interview has an end date that is in the past. When you open the interview the end date will be removed. You can set a new end date from the ' :
        'This interview round has an end date that is in the past. When you open the interview round the end date will be removed. You can set a new end date from the ',
      endTimeInPastLink: 'edit page',
      cancel: 'Cancel',
    },

    modalInterviewSelectForEdit: {
      title: 'Edit Interview',
      info: 'Choose the interview you want to edit.',
      cancel: 'Cancel',
      done: 'Done',
      error: {
        selectInterview: 'Please select interview.',
      },
    },

    modalJobAdPreview: {
      title: 'Job ad preview',
      close: 'Close',
      description: 'You see here how the job ad looks like for the candidate.',
      description2:
        'Note that the language used in the preview is not the language set for the job ad.',
      back: 'Back',
    },

    modalJobAdStatus: {
      change: 'Change job status',
      changed: 'Job status changed',
      changedInfo:
        'Job status changed. Remember to inform candidates about decisions!',
      info: 'Select the new status for the job position. Setting status to "Filled" or "Cancelled" will guide you through the necessary steps for selecting the hired persons and/or sending the remaining "No thank you"-messages',
      open: 'Open',
      filled: 'Filled',
      cancelled: 'Cancelled',
      done: 'Done',
      close: 'Close',
      draft: 'Closed (draft)',
      closed: 'Closed',
      unpublished: 'Unpublished',
      hidden: 'Hidden',
      openDescription: 'Job ad is published until',
      filledDescription:
        'Close the job ad because the position has been filled.',
      cancelledDescription:
        'Close the job ad because the recruitment process has been cancelled.',
      closedDescription:
        'Job ad is closed. The job ad is not accessible or visible to the candidates.',
      hiddenDescription:
        'Hide the position from career page. Position is only accessible with direct link:',
      unpublishedDescription:
        'Job ad is not published. The job ad is not accessible or visible to the candidates.',
      cancel: 'Cancel',
    },

    modalJobPositionTeam: {
      addAnother: 'Add more users by submitting their email addresses',
      team: 'Recruitment team',
      info: 'You can add colleagues or other users to review and evaluate candidates',
      newMembersMsg:
        'New team members without an existing account in Recright will be added to the organisation where this position belongs to.* If the user’s email domain does not match with the domain linked to the organisation, the user will get only minimal user permissions. The user permissions can be changed later on by admins who have access to the user management.',
      asteriskSymbol: '*',
      currentTeam: 'Current team',
      done: 'Done',
      remove: 'Remove',
      submit: 'Add team members',
      cancel: 'Cancel',
      selfRemovedMessage:
        'You have removed yourself from the recruitment team.',
      successMessage: count =>
        `${count} members added to the recruitment team.`,
      errors: {
        duplicate: 'Email has already been added.',
        duplicateMultiple:
          'Team member(s) already found with one or more emails submitted.',
        isEmail: 'Email is invalid.',
        isEmailMultiple: 'Invalid emails found.',
        isRequired: 'Field is required.',
      },
    },

    modalJobPositionCopy: {
      title: (context, position) =>
        `Are you sure you want to make a copy of the ${
          context === 'jobAd' ? 'job' : 'interview'
        } "${position.title}"?`,
      admins: 'Do you also want to copy the recruitment team?',
      done: 'Copy',
      cancel: 'Cancel',
    },

    modalVideos: {
      title: 'Video library',
      yourVideos: 'Your videos',
      companyVideos: 'Company videos',
      add: 'Add',
      done: 'Add videos',
      cancel: 'Cancel',
      selectedVideos: 'Selected videos',
      clearAll: 'Clear all',
    },

    videoCollectionBrowser: {
      allVideos: 'All videos',
      noCollections: 'No collections',
      videoCountSingular: 'video',
      videoCountPlural: 'videos',
      folderView: 'Folder view',
      listView: 'List view',
      sort: {
        createdAt: 'Creation date',
        title: 'Title',
      },
    },

    modalUsersAdd: {
      title: 'Invite users',
      languageDescription: 'These users will have the following language:',
      permissionsDescription:
        'These users will have the following permissions:',
      emailsPlaceholder: "Enter the user's email addresses",
      seeAllPositions: 'See all positions',
      createJobPositions: 'Create job position',
      createInterviews: 'Create interviews',
      account: 'Edit company info',
      billing: 'Billing',
      reporting: 'Reporting',
      editUsers: 'Edit users',
      default: 'Company default permissions',
      cancel: 'Cancel',
      submit: 'Invite users',
    },

    modalCompanyDefaultPermissionsEdit: {
      title: 'Company default permissions:',
      description:
        'All new users who sign up to this company will automatically have the default permissions.',
      seeAllPositions: 'See all positions',
      createJobPositions: 'Create job position',
      createInterviews: 'Create interviews',
      account: 'Edit company info',
      billing: 'Billing',
      reporting: 'Reporting',
      editUsers: 'Edit users',
      cancel: 'Cancel',
      submit: 'Save',
    },

    modalOtherApplications: {
      title: 'Candidate in other positions',
      header: 'Here is a list of the same candidate in other positions',
      close: 'Close',
    },

    getPermissionsLabels: {
      permissions: {
        seeAllPositions: 'See all positions',
        createJobPositions: 'Create job position',
        createInterviews: 'Create interviews',
        account: 'Edit company info',
        billing: 'Billing',
        reporting: 'Reporting',
        editUsers: 'Edit users',
        default: 'Default permissions',
      },
    },

    modalCronofy: {
      linkCalendar: {
        title: 'Calendar connection',
        description:
          'Take the stress out of scheduling by allowing your candidates to self-schedule meeting with you straight from Recright. First, connect your calendar to Recright using Cronofy.',
        authorize: 'Connect your calendar here',
        authorized: profileName =>
          `You have successfully linked calendar ${profileName} to your Recright account! Now you can invite candidates to self-scheduled meetings!`,
        revokeAuthorization: 'Remove calendar connection',
      },
      personalInterview: {
        title: 'Schedule a meeting',
        description:
          'If you’d like to meet the candidate in person, you may invite them to self-schedule a meeting. First, choose the interviewers for the meeting, then set your availability by choosing the dates, times as well as the length of the slots. Add in a message to personalize your invitation. \n\nThe candidate will receive an email to book the meeting. When the candidate chooses a time slot, the interviewers will get an email confirmation with the candidate’s details, and the meeting will appear on the calendar.',
        interviewersHeader: 'Select interviewers',
        noInterviewersSelectedRegular: 'Select at least one interviewer',
        noInterviewersSelected:
          'Select at least one interviewer with connected calendar to continue',
        otherInterviewersHeader: 'Other interviewers',
        removeOtherInterviewers: 'Remove',
        deselectAll: 'Deselect all',
        selectAll: 'Select all',
        interviewerCalendarNotConnected:
          "The user's calendar is not connected to Recright, and their availability information cannot be accessed.",
        interviewerCalendarNotConnected2:
          "They'll receive an email with scheduling information and instructions on how to connect their calendar to Recright.",
        singleInterviewer: 'Interviewer',
        allInterviewersCalendarNotConnected:
          'None of the interviewers have their calendar connected to Recright',
        addMoreInterviewersToTeam:
          'Click here to add more interviewers to the team',
        userCalendarNotConnected: 'Your calendar is not connected to Recright',
        userConnectCalendar: 'Connect your calendar here',
        addNewInterviewer: "Add new interviewer's email address",
        timeSlot: {
          description:
            "Set the time frame and the slot length for meetings. \nOnce you have selected the interviewers and the time frame, you'll see what slots will be visible to the candidate.",
          startDate: 'Time frame start date',
          endDate: 'Time frame end date',
          endDatePlaceholder: 'End date',
          startDatePlaceholder: 'Start date',
          endDateWarning:
            'Select the time frame end date for the scheduled meetings',
          startTime: 'From',
          endTime: 'To',
          timezone: 'Time zone',
          timezoneHelp:
            'Please note that changing the timezone also adjusts date and time accordingly.',
        },
        useAllTimeSlots:
          'Allow the candidate to choose from all the available time slots in the selected time frame.',
        noTimeSlotsSelected:
          'Select at least one timeslot from the Availability calendar below or \nlet the candidate choose from all available time slots by checking the checkbox above.',
        slotPickerDescription:
          'See what slots are available for candidate to choose from. The changes in the calendars are updated automatically to Recright',
        showAvailability: 'Show availability',
        refreshAvailability: 'Refresh availability',
        slotLength: 'Slot length',
        availabilityError:
          'Unable to show availability. Please try again later and if the problem persists please contact our support.',
        recipients: count => `Message will be sent to ${count} candidates`,
        confirmRescheduleMessage: 'Reschedule meeting',
        confirmRescheduleContent:
          'Some recipients already have a meeting scheduled. Do you want to send new invitations? This will overwrite their previously scheduled meeting.',
      },
      personalInterviewMessage: {
        title: 'Write an invitation message',
        successTitle: 'Great',
        successDescription: candidateLength =>
          `You invited ${candidateLength} people to personal interview. They have also been moved to stage 'Personal Interview'`,
        message: {
          emailMessage: 'Message',
          title: title => `Let’s have a meeting regarding ${title}`,
          content: title =>
            `Hey! We were impressed with your application for ${title} position and would like to invite you for a meeting and tell you a little more about the position and get to know you better.\n\nPlease let me know which of the following times best for you by clicking this scheduling link.\n\nLooking forward to meeting you!`,
          event: {
            header: 'Meeting Location',
            description: 'Enter here your meeting details:',
            titlePlaceholder: 'Meeting title',
            locationPlaceholder: 'Enter a location',
          },
        },
        close: 'Close',
        saveDefaultLocation: 'Save location as default location',
        savedDefaultLocation: 'Saved as default location',
        invitationError:
          'We were unable to send calendar invitation. Please try again later and if the problem persists please contact our support.',
      },
    },

    modalVideoEdit: {
      title: 'Edit a video',
      cancel: 'Cancel',
      save: 'Save',
      addToCollection: 'Add to collection',
      success: 'Successfully saved the changes to a video',
      error:
        'We were unable to save the changes to a video. Please try again later and if the problem persists please contact our support.',
    },

    noResults: {
      description:
        'Your list seems to be empty. If you are filtering the list try to reduce some filters.',
    },

    notifications: {
      notifications: 'Notifications',
    },

    notificationsSubscribeButton: {
      subscribe: 'Subscribe',
      subscribed: 'Subscribed',
      unsubscribe: 'Unsubscribe',
    },

    onboardTutorial: {
      ui: {
        back: 'Back',
        close: 'Close',
        last: 'Last',
        next: 'Next',
        skip: 'Turn off',
      },
      dashboard: [
        {
          title: 'Welcome to Recright!',
          text: 'First things first—let’s connect your calendar, so you can schedule meetings with your candidates quickly, without sending emails back and forth! <a href="/admin/account">Connect your calendar here!</a>',
          selector: '.joyride--welcome-calendar',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: 'Welcome to Recright!',
          text: 'We will guide you through the tool with interactive guides. You can view the help text regarding each function through clicking the pulse. Guides can be made visible again at anytime through clicking your name and "Show tutorial".',
          selector: '.joyride--welcome',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: 'Create new job position',
          text: 'Create and publish a new job position and start receiving applications here.',
          selector: '.joyride--add-job-ad',
          position: 'bottom-left',
        },
        {
          title: 'Create new video interview',
          text: 'Create a new video interview and invite candidates here.',
          selector: '.joyride--add-videointerview',
          position: 'bottom-left',
        },
        {
          title: 'Settings',
          text: 'Change your account settings, choose your career page look and URL, manage your video library and select preferred language here. You can also switch this pulse guide on by clicking "Show tutorial".',
          selector: '.joyride--profile-settings',
          position: 'bottom-left',
        },
      ],
      accountDetails: [
        {
          title: 'Connect your calendar here!',
          text: 'Once you have connected your calendar to Recright, you can start inviting candidates to self-schedule meetings with you, and your calendar will be automatically updated.',
          selector: '.joyride--connect-calendar',
          position: 'top',
        },
      ],
      jobAdEdit: [
        {
          title: 'Add head banner and logo',
          text: 'You can add a head banner to the job ad and visible to your candidates. Optimal image size is 1440 x 320 pixels. Remember to add your logo as well.',
          selector: '.joyride--job-ad-images',
          position: 'top',
        },
        {
          title: 'Title, location, publish dates',
          text: 'Type in position title, location, set the publish date and deadline. If Open until is left blank, position is open for now.',
          selector: '.joyride--job-ad-title',
          position: 'top',
        },
        {
          title: 'Job description',
          text: "Type in or paste your job description here. Remember to mention at least what you're looking for, what are the requirements and what you have to offer.",
          selector: '.joyride--job-ad-description',
          position: 'top',
        },
        {
          title: 'Employer video',
          text: 'You can promote your company culture and enhance employer branding by adding an employer video to the job ad.',
          selector: '.joyride--job-ad-employer-video',
          position: 'top',
        },
        {
          title: 'Application form setup',
          text: 'Choose which information you wish to know from your candidates. Fields can be optional or mandatory to answer.',
          selector: '.joyride--job-ad-application-setup',
          position: 'top',
        },
        {
          title: 'Video question',
          text: 'You can ask a specific video question from your candidates already in application phase and bring the applications alive through video answers. This is also a great opportunity for you to say hello to your candidates.',
          selector: '.joyride--job-ad-video-questions',
          position: 'right',
        },
      ],
      interviewEdit: [
        {
          title: 'Add head banner and logo',
          text: 'You can add a head banner to the interview and visible to your candidates. Optimal image size is 1440 x 320 pixels. Remember to add your logo as well.',
          selector: '.joyride--interview-images',
          position: 'top',
        },
        {
          title: 'Title, open until',
          text: 'Type in the title for your video interview and set up answering deadline. If you leave "Open until" blank, the interview is open for now.',
          selector: '.joyride--interview-title',
          position: 'top',
        },
        {
          title: 'Interview form setup',
          text: 'Choose which information you wish to know from your candidades. Fields can be optional or mandatory to answer.',
          selector: '.joyride--interview-form-setup',
          position: 'top',
        },
        {
          title: 'Interview questions',
          text: "Record or upload your video questions. You can save video questions to library after adding them and reuse them later. You can also use text questions if you don't have the possibility to use video questions. Candidates always answer with video.",
          selector: '.joyride--interview-video-questions',
          position: 'top',
        },
      ],
      createdJobAd: [
        {
          title: 'Job position actions',
          text: 'Here you can edit the job position, change its status and invite your team to evaluate the candidates.',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: 'Promoting a job position',
          text: 'Promote your job ad and let your candidates find it by sharing the job ad to social media.',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      createdInterview: [
        {
          title: 'Video interview actions',
          text: 'Here you can edit the video interview, change its status and invite your team to evaluate the candidates.',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: 'Inviting and publishing a video interview',
          text: 'Invite candidates to your video interview or make your video interview public and promote it by sharing video interview to social media.',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      ApplicationView: [
        {
          title: 'Comments and classifications',
          text: "You can comment the candidates, classify them with tags, and rate them with stars. Remember to set a suitable status for the candidate so that your team knows your decision. Candidates don't see this information.",
          selector: '.joyride--comments',
          position: 'top',
        },
      ],
    },

    organisationSubMenu: {
      index: 'Organisation profile',
      branding: 'Branding',
      stages: 'Stages',
      emailTemplates: 'Email templates',
      evaluationScales: 'Evaluation scales',
      competencies: 'Competencies',
    },

    passcode: {
      passcode: 'Passcode',
      showPasscode: 'Show passcode',
      hidePasscode: 'Hide passcode',
    },

    passwordIndicator: {
      errors: [
        'The password must be at least 12 characters.',
        'The password must be fewer than 128 characters.',
        'The password may not contain sequences of three or more repeated characters.',
        'The password should contain at least one lowercase letter: a-z',
        'The password should contain at least one uppercase letter: A-Z',
        'The password should contain at least one number: 0-9',
        'The password should contain at least one special character: (e.g. !, #, &)',
      ],
      strengthLabel: 'Password Strength: ',
      strengthValue: {
        insufficient: 'Insufficient',
        weak: 'Weak',
        medium: 'Medium',
        strong: 'Strong',
      },
      learnMore: 'Learn how to create strong password',
    },

    personDetails: {
      namePlaceholder: 'Candidate',
      links: 'Links',
      attachments: 'Attachments',
      coverLetter: 'Cover Letter',
      referrer: 'Origin',
      referrerInfo: 'The website from which the candidate came to the service.',
      lastSeen: time => `Last seen ${time}.`,
      headerAdditionalInformation: 'Additional information',
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
      },
      liveCandidateState: {
        scheduling: 'Interview time selection',
        notInvited: 'No invitation sent',
        invited: 'Invited',
        interviewed: 'Interviewed',
        evaluated: 'Evaluated',
      },
      notVisited: "Hasn't yet visited the interview.",
      otherPersons: count => `Also found on ${count} other positions`,
      name: 'Name',
      city: 'Hometown',
      email: 'Email',
      phone: 'Phone Number',
      deadline: date => `Deadline: ${date}`,
      deadlineExpired: 'Deadline has passed',
    },

    personEdit: {
      header: 'Edit candidate details',
      description: context =>
        `You can edit all basic candidate information that is visible for candidates on the ${
          context === 'application' ? 'application' : 'interview'
        } form.`,
      name: ' Candidate name',
      email: 'Candidate Email',
      city: "Candidate's current hometown",
      phone: 'Candidate phone number',
      link: "Add link, for example candidate's LinkedIn profile.",
      links: "Add links, for example candidate's LinkedIn profile",
      coverLetter: 'Cover letter',
      attachments: 'Attachments',
      save: 'Save',
      cancel: 'Cancel',
      editDetails: 'Edit details',
      editSuccess: 'Candidate details saved!',
    },

    personRow: {
      noStage: 'Not in any stage yet',
      lastSeen: time => `Last seen ${time}.`,
      notVisited: "Hasn't yet visited the interview.",
      selectPerson: 'Select',
      deselectPerson: 'Remove Selection',
      openPersonPage: 'Open',
      interviewStartTime: 'Interview start time',
      noStartTimeSelected: 'No start time selected',
      icons: {
        messages: messagesSent => `${messagesSent} messages sent`,
        message: messagesSent => `${messagesSent} message sent`,
        noMessages: 'No messages sent',
        introduction: introductions => `${introductions} introduction`,
        introductions: introductions => `${introductions} introductions`,
        noIntroductions: 'No introductions',
        comment: comments => `${comments} comment`,
        comments: comments => `${comments} comments`,
        noComments: 'No comments',
        appliedWithLinkedIn: 'User applied with LinkedIn',
      },
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
        scheduling: 'Interview time selection',
        notInvited: 'No invitation sent',
        interviewed: 'Interviewed',
        evaluated: 'Evaluated',
      },
      deadline: date => `Deadline: ${date}`,
      deadlineExpired: 'Deadline has passed',
    },

    pipeline: {
      editInterview: 'Edit interview',
      titleLabel: 'Title',
      endTimeLabel: 'Open until',
      statusLabel: 'Status',
      locationLabel: 'Location',
      editStages: 'Edit stages',
      interviewSchedulingDescription:
        'This stage contains candidates that have been invited to a personal meeting.',
      pipelineTooltip:
        'Track your candidates throughout the hiring process. Move candidates along the different stages of the recruitment pipeline. You can filter applications by stages or other criteria.',
    },

    positionListing: {
      type: 'Position type',
      title: 'Title',
      owner: 'Owner',
      created: 'Creation time (GMT)',
      start: 'Publish date (GMT)',
      end: 'End date (GMT)',
      count: 'Applications',
      invited: 'Invited',
      visited: 'Visited',
      answered: 'Answered',
      hired: 'Hired',
      leadTime: 'Lead time',
      leadTimeValue: v => `${v} days`,
      jobAdLabel: 'Job ad',
      interviewLabel: 'Video interview',
      timedLabel: 'Timed video interview',
      embedLabel: 'Embedded interview',
      publicLabel: 'Public interview',
      timezone: 'Timezone',
      feedback: 'Feedback statistics',
    },

    qrCodeDownload: {
      download: 'Download QR code',
    },

    recentPositionsContainer: {
      createNew: 'Create new',
      showAll: 'Show all',
    },

    recentJobAds: {
      openJobPositions: 'Job positions',
      showAllJobPositions: 'Show all job positions',
      createNewJobPosition: 'Create new job position',
      subscriptionNeeded:
        'You need an active subscription to publish this job position.',
      confirmSingleHire:
        'One of your purchased single hires are used for this job position.',
      newApplications: 'Unseen',
      responses: 'Applications',
    },

    recentInterviews: {
      openVideoInterviews: 'Video interviews',
      showAllVideoInterviews: 'Show all video interviews',
      createNewVideoInterview: 'Create new video interview',
      invites: 'Invites',
      responses: 'Responses',
      timedTitle: 'Timed video interview',
    },

    registrationForm: {
      email: 'Email',
      submit: 'Log in to the service',
      password: 'Password',
      confirmPassword: 'Confirm password',
      agreeTos: 'I have read and approve ',
      agreeTosLinkText: 'the Recright User Terms and Conditions',
      privacyPolicy: 'I have familiarised myself with the ',
      privacyPolicyLinkText: 'Privacy Policy.',
      licenseAgreement: 'On behalf of the organisation I represent I accept ',
      licenseAgreementLinkText: "Recright's General Terms of Service.",
      newsletter: 'Subscribe to monthly newsletter.',
      name: 'Name',
      namePlaceholder: 'Firstname Lastname',
      organization: 'Organisation',
      companyDomain: domain =>
        `Allow users signing up with ${domain} domain to be added to this company.`,
      error: {
        password: {
          isRequired: 'Password is required. ',
          isValidPassword: 'A valid password must be minimum of 12 characters including at least one uppercase letter, one lowercase letter and one number.',
          passwordsMatch: 'Passwords do not match. ',
        },
      },
    },

    subscriptionNeededAlert: {
      contactPersonWithBillingPermission:
        'Please contact person responsible for billing in your organisation.',
    },

    search: {
      placeholder: 'Search',
    },

    searchFilter: {
      filter: 'Filter',
      headings: {
        location: 'Location',
        state: 'Progress',
        status: 'Status',
        tags: 'Tags',
        rating: 'Rating',
        stage: 'Stage',
      },
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
        scheduling: 'Interview time selection',
        notInvited: 'No invitation sent',
        interviewed: 'Interviewed',
        evaluated: 'Evaluated',
      },
      status: {
        open: 'Open',
        filled: 'Filled',
        cancelled: 'Cancelled',
        closed: 'Closed',
        draft: 'Draft',
        unpublished: 'Unpublished',
        hidden: 'Hidden',
        hired: 'Hired',
        new: 'New',
        all: 'All',
        proceed: 'Proceed',
        videointerviewed: 'Video interview',
        personalinterview: 'Personal interview',
        scheduledinterview: 'Scheduled meeting',
        withdrawn: 'Withdrawn',
        rejected: 'Rejected',
        finished: 'Finished',
        coming: 'Upcoming',
        active: 'Ongoing',
      },
    },

    selectListings: {
      title: 'Listings',
      description: 'Select listings where position is published.',
    },

    session: {
      account: 'Account management',
      language: 'Language',
      logout: 'Log out',
      whatsNew: "What's New",
      trainingMaterial: 'Recright trainings',
      expired: 'Please log in again.',
      showTutorial: 'Show tutorial',
      helpCenter: 'Recright Help Center',
      organization: 'Organisation',
    },

    showFeedbackPulse: {
      showPulse: 'Show feedback',
      positive: avg => `${avg}% Positive`,
      feedbackStatistics: 'Feedback statistics',
      noFeedback: 'No feedback yet',
      responses: responses => `${responses} Responses`,
    },

    singleHireUseNotification: {
      notificationHeader: count =>
        `You have ${count} single hires left in your account.`,
      notificationBody:
        'By inviting candidates or publishing the interview one single hire will be used.',
    },

    singleHires: {
      currentCount: count => `${count} single hires available.`,
      label: 'Single hire',
      purchase: 'Purchase a single hire',
      confirmMessage: amount =>
        `Confirm your single hire purchase. ${amount} EUR will be charged from your credit card.`,
    },

    smartrecruitersPublish: {
      title: 'Smartrecruiters Integration',
      description:
        'You can add and remove individual interviews from the Video Interview list in Smartrecruiters.',
      notification:
        'Please note that it can take up to 24 hours before the interviews will appear in Smartrecruiters.',
      addButton: 'Add to Smartrecruiters',
      removeButton: 'Remove from Smartrecruiters',
      confirmRemove:
        'Are you sure you want to remove the interview from Smartrecruiters?',
      addConflict:
        'Interview has already been added to the Video Interview list',
      removeConflict:
        'Interview has already been removed from the Video Interview list',
    },

    subscriptionExpired: {
      message: 'Your subscription has expired.',
    },

    stars: {
      yourRating: rating => `Your rating: ${rating}`,
      totalVotes: count => `Total ${count} ratings`,
      yourRatingReset: 'Reset your vote',
    },

    statisticsFilters: {
      timeframe: 'Search timeframe',
      owner: 'Owner (Optional)',
    },

    csStatisticsFilters: {
      timeframe: 'Timeframe',
      autoSuggestCompany: 'Company name',
      companyId: 'Company ID',
      companyDomain: 'Company domain',
      note: 'Note: ',
      noteText:
        'Company name is case sensitive. Company name suggestions are only shown for companies with > 1 jobads or jobopenings.',
    },

    statisticsSummary: {
      jobCountLabel: 'Open job count',
      interviewsLabel: 'Video interviews',
      applicationsLabel: 'Job applications',
      answersLabel: 'Interview answers',
      activeUsersLabel: 'Active users',
      avgLeadTimeLabel: 'Average lead time',
      avgLeadTimeValue: value => `${value} days`,
    },

    status: {
      opening: {
        open: 'Open',
        filled: 'Filled',
        cancelled: 'Cancelled',
        closed: 'Closed',
        draft: 'Draft',
        unpublished: 'Unpublished',
        hidden: 'Hidden',
      },
      person: {
        hired: 'Hired',
        proceed: 'Proceed',
        new: 'New',
        videointerviewed: 'Video interview',
        personalinterview: 'Personal interview',
        scheduledinterview: 'Scheduled meeting',
        withdrawn: 'Withdrawn',
        rejected: 'Rejected',
      },
    },

    trialBanner: {
      notification: days =>
        `You have a ${days} days left of your trial period. If you want to continue to use after the trial period, please subscribe.`,
      trialEnded:
        'Your trial period has now ended. Please purchase a subscription or a single hire to continue using the service.',
      orderHere: 'Subscribe here!',
    },

    favorite: {
      popupHeader: 'Select video library',
      yourVideos: 'Your videos',
      companyVideos: 'Company videos',
    },

    FavoritesInfo: {
      Favorites: videoLibrary =>
        `Add videos to your favorites by clicking the heart icon. You can remove videos from your favorites by visiting <a href="${videoLibrary}">Video Library</a>.`,
    },

    brandingPreview: {
      preview: 'Preview',
      header: 'Sample heading',
      body: lorem => `This is sample text font. ${lorem}`,
      linkText: 'This is a sample link.',
      primaryButtonText: 'Primary button',
      secondaryButtonText: 'Secondary button',
      backButtonText: 'Back button',
    },

    usersList: {
      generalInformation: 'General information',
      latestVisit: date => `Latest visit ${date}`,
      neverLogger: 'Never logged in',
      externalUser: 'External user',
      inviteExpired: 'Invite expired',
      permissions: {
        permissions: 'Permissions',
        seeAllPositions: 'See all positions',
        createJobPositions: 'Create job position',
        createInterviews: 'Create interviews',
        account: 'Edit company info',
        billing: 'Billing',
        reporting: 'Reporting',
        editUsers: 'Edit users',
        default: 'Default permissions',
      },
      actions: {
        actions: 'Actions',
        activate: 'Activate',
        deactivate: 'Deactivate',
        removeFromOrganisation: 'Remove from organisation',
        hiddenPositions: 'Hidden positions',
      },
      noUsers:
        'No users. If you filtered the list, try reducing the number of filters.',
    },

    usersListFilters: {
      sort: {
        name: 'Name',
        email: 'Email',
        lastAdminAccess: 'Last admin access',
      },
      find: 'Search',
      clearSelections: 'Clear selections',
      usersCount: count => `Total ${count} users`,
    },

    usersListActions: {
      editMultipleUsersPermissions: "Edit multiple users' permissions",
      deactivateSelectedUsers: 'Deactivate selected users',
      activateSelectedUsers: 'Activate selected users',
      addNewUsers: 'Invite users',
      save: 'Save',
      cancel: 'Cancel',
      editUsersPermissions: "Edit users' permissions",
    },

    linkedInInformation: {
      title: 'LinkedIn information:',
      since: 'Since',
      summary: 'Summary:',
      fullLinkedInProfile: 'Full LinkedIn profile',
    },

    colorPicker: {
      reset: 'Reset',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined:
          'Email bounced back. Make sure the recipient received your message.',
      },
      Permanent: {
        General:
          'Email delivery failed. Recipients email provider rejected the message.',
        NoEmail: 'Email address does not exist.',
        Suppressed:
          'Email was not delivered due to previous unsuccessful delivery attempts.',
      },
      Transient: {
        General:
          'Email bounced back. Make sure the recipient received your message.',
        MailboxFull: 'Recipient inbox is full.',
        MessageTooLarge: 'The message content is too large.',
        ContentRejected: 'The message content rejected.',
        AttachmentRejected: 'The attachment rejected.',
      },
    },

    videoBackgroundUpload: {
      header: 'Organisation video background',
      description:
        "Image that your organisation's users can use as a background image for videos they record.",
      add: 'Add video background image',
      info: 'Recommended image size is 720x480 pixels.',
    },
  },

  page: {
    account: {
      title: 'Account management',
      details: 'Account details',
      name: 'Account name',
      save: 'Save',
      saved: 'Account information saved.',
      signature: 'Signature',
      permissions: 'Permissions',
      calendar: {
        label: 'Calendar',
        notAuthorized: 'Connect your calendar here',
        authorized: 'Manage your calendar connection',
        revokeError:
          'We were unable to unlink your calendar. Please try again later and if the problem persists please contact our support.',
        revokeSuccess: 'Successfully unlinked your calendar',
      },
      password: 'Password',
      statistics: 'Statistics',
      organization: 'Organisation',
    },

    actionBar: {
      selection: 'selected',
    },

    organisationProfile: {
      title: 'Organisation profile',
      brandingHeader: 'Organisation branding',
      details: 'Organisation profile settings',
      name: 'Organisation name',
      owner: 'Account owner',
      customReplyToSubtitle:
        'The sender name and reply address for the interview invitations. If left empty, the name and email of the user sending the invites are used.',
      customReplyToEmail: 'Reply email for interview invitations',
      customReplyToName: 'Sender name for interview invitations',
      senderInfoDisabled:
        'Updating the interview invitation sender information is disabled because video interviews are disabled for your organisation.',
      slug: 'Careers site URL',
      slugUnavailable: 'This URL is already reserved.',
      slogan: 'Careers site slogan',
      language: 'Careers site language',
      languagePlaceholder: 'Choose',
      rss: 'Careers RSS feed',
      type: 'Account type',
      save: 'Save',
      reset: 'Reset',
      saved: 'Organisation information saved.',
      types: {
        free: {
          title: 'Free',
          description: 'Benefits of free\n1 user\n1 open job position at time',
        },
        basic: {
          title: 'Basic',
          description:
            'Benefits of free\nUnlimited open job positions\nVideo interviews',
        },
        team: {
          title: 'Team',
          description:
            'Benefits of Team\nUnlimited open job positions\nVideo interviews\nCandidate presentations',
        },
      },
      companyAdminUsers: 'Company admin users',
      cancel: 'Cancel',
      confirmLeave: 'You have unsaved changes. Are you sure you want to leave?',
      error: {
        required: 'Fields marked with * asterisk are mandatory',
      },
      emailBrandingHeader: 'Email branding',
      emailBrandingDescription: 'Customise the colors of the emails sent to the candidates.',
    },

    organisationCompetencies: {
      title: "Organisation's competencies",
      description:
        'You can edit, add and delete organisation competencies here. These will be the default competencies in new positions created under this company and can be found on candidates in those positions in the "Competencies and compatibility" section.',
    },

    organisationStages: {
      title: "Organisation's recruitment stages",
      description:
        'You can edit, add, delete and reorder organisation stages here. These will be the default recruitment stages in new positions created under this company.',
    },

    organisationEvaluationScales: {
      language: 'Language',
      name: 'Name',
      description: 'Description',
      resetToDefaults: 'Reset to defaults',
      confirmLanguageChange:
        'Are you sure you want to change the language? All your unsaved changes will be lost.',
    },

    organisationEmailTemplates: {
      preview:
        "Preview the email (the preview doesn't have all the formatting of the final email)",
      preview2: "Email template colors can be customised on the organisation's branding settings page.",
      timedInterviewPreviewInfo:
        'The message for timed video interview does not contain the part about contacting the support.',
      templateTypes: {
        interviewInvite: 'Video interview invitation',
        timedInterviewInvite: 'Timed video interview invitation',
        interviewCompleted: 'Interview completed / Thank you message for video interview candidate',
        applicationCompleted: 'Job application completed / Thank you message for job ad applicant',
      },
      subHeaders: {
        jobAdLabel: 'Job ad',
        interviewLabel: 'Video interview',
      },
      deleteTemplate: 'Delete template',
      confirmation: templateName =>
        `Are you sure you want to delete the template "${templateName}" from your organisation email templates?`,
      deleteSuccess:
        'The template was deleted from the organisation email templates.',
      emailTemplateInfo:
        'This feature is under development. Currently you can only save one template',
      templateError: 'Template with same name or language already exists.',
    },

    application: {
      back: 'Back to application list',
      delete: 'Delete application',
      deleted: 'Application deleted',
      interviewClosed: 'Interview is closed.',
      resendInvitation: 'Resend invitation to applicant',
      changeStage: 'Move to another stage',
      commentsAndClassifications: 'Comments and classifications',
      openingTitle: title => `Video interview - ${title}`,
      yourRatingText: 'Your rating:',
      competencesAndCompatibility: 'Competencies and compatibility',
      duplicateCompetency: 'Competency already exists',
      competencyNotFound: 'Competency not found or removed',
      confirmDelete: 'Are you sure you want to delete this application?',
      lastSeen: time => `Last seen ${time}.`,
      stageChanged: 'Great!',
      stageChangedInfo: stage =>
        `Now that you have moved the candidate to the stage "${stage}" let them know about it! \n\n Send them an email or video message.`,
      close: 'Close',
      reopenProcessConfirm:
        'Are you sure you want to move this candidate away from the "Withdrawn" stage and return them back to the recruitment process? After confirming, the candidate will again be able to answer to the interview if they have not yet completed.',
      withdrawConfirm:
        'Are you sure you want to withdraw this candidate from the recruitment process? If withdrawn, the candidate is no longer able to access the interview.',
      changestageTooltip:
        'You can see the current stage where the candidate is at. You can manually set the stage by clicking on the desired stage. The candidate will not be notified about this.',
      commentsTooltip:
        'You can leave comments about the candidate’s application for your colleagues to see. The candidate is not able to access this information.',
      competencesTooltip:
        'You can add or rate a competency. Your colleagues can see and rate the competencies you have added, as well as create new ones. The candidate cannot see this information.',
      actionlogTooltip:
        'Comments, stage changes, messages and other activities will appear here. The candidate cannot see this information.',
      stage: {
        new: 'New',
        hired: 'Hired',
        proceed: 'Proceed',
        personalinterview: 'Personal interview',
        scheduledinterview: 'Scheduled meeting',
        withdrawn: 'Withdrawn',
        rejected: 'Rejected',
        videointerviewed: 'Video interview',
      },
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
      },
      notVisited: "Hasn't yet visited the interview.",
      deadline: date => `Deadline: ${date}`,
      deadlineExpired: 'Deadline has passed',
    },

    billing: {
      title: 'Billing',
      nextPayment: (nextBillingPeriodAmount, nextBillingDate) =>
        `Next billing will be ${nextBillingPeriodAmount} EUR at ${nextBillingDate}`,
      status: 'Status',
      singleHire: 'Single hire',
      billingOverview: 'Billing overview',
      payment: 'Payment',
      paymentHistory: 'Payment history',
      updateDetails: 'Update billing details',
      billingStatus: {
        pending: 'Pending',
        active: 'Active',
        pastdue: 'Past Due',
        expired: 'Expired',
        canceled: 'Cancelled',
      },
      noContractsFound: 'No contracts found. Please contact customer support.',
      monthlyPrice: 'Monthly Price:',
      productName: 'Product Name:',
      products: 'Products',
      nextInvoiceDate: 'Next Invoice Date:',
      monthlyValue: 'Monthly Value:',
      invoiceFrequency: 'Invoice Frequency:',
      months: '(months)',
      nextInvoiceSum: 'Next Invoice Sum:',
      contractStatus: 'Contract Status:',
      contractStartDate: 'Contract Start Date:',
      contractEndDate: 'Contract End Date:',
      termOfNotice: 'Term of Notice:',
      contract: 'Contract',
    },

    candidate: {
      actionLog: 'Action Log',
      back: 'Back to candidate list',
      delete: 'Delete candidate',
      deleted: 'Candidate deleted',
      interviewClosed: 'Interview is closed. No reinvites were sent.',
      resendInvitation: 'Resend invitation to candidate',
      changeStage: 'Move to another stage',
      introducedTo: 'Introduced to:',
      yourRatingText: 'Your rating:',
      competencesAndCompatibility: 'Competencies and compatibility',
      duplicateCompetency: 'Competency already exists',
      competencyNotFound: 'Competency not found or removed',
      confirmDelete: 'Are you sure you want to delete this candidate?',
      stageChanged: 'Great!',
      stageChangedInfo: stage =>
        `Now that you have moved the candidate to the stage "${stage}" let them know about it! \n\n Send them an email or video message.`,
      close: 'Close',
      hideStages: 'Hide stages',
      showStages: 'Show stages',
      resetQuestionResponseSuccess: 'Candidate response was deleted',
      stage: {
        new: 'New',
        hired: 'Hired',
        proceed: 'Proceed',
        personalinterview: 'Personal interview',
        scheduledinterview: 'Scheduled meeting',
        withdrawn: 'Withdrawn',
        rejected: 'Rejected',
        videointerviewed: 'Video interview',
      },
      summaryOfAllAnswers: 'Summary of all answers',
      summaryOfAllAnswersInsights: 'Summary of all insights',
    },

    dashboard: {
      upcomingLiveInterviews: 'Live interviews',
      showAllLiveInterviews: 'Show all live interviews',
      createNewLiveInterview: 'Create new live interview',
      interviewRounds: 'Interview rounds',
      interviewGuides: 'Interview guide templates',
      welcome: name => `Welcome, ${name}!`,
      createNewGuide: 'Create new interview guide template',
      liveCard: {
        startTime: 'Start time',
        interviewers: 'Interviewers',
        candidates: 'Candidates',
      },
      interviewRoundCard: {
        interviews: 'Interviews',
        admins: 'Admins',
        endTime: 'Open until',
      },
      oldLivesLinkText: 'Old live interviews',
    },

    interviewEdit: {
      title: 'Type in interview title',
      titleLabel: 'Interview title',
      location: 'Location',
      publishTimePlaceholder: 'Publish date',
      publishTimeTooltip:
        'Set a publish date for the interview. You can change the date anytime you want.',
      endTime: 'Open until',
      endTimeTooltip: 'Select a closing date for the response period.',
      candidateAnswerTimeDays: 'Days to submit answers',
      candidateAnswerTimeDaysTooltip: 'Set the number of days each candidate has to complete the interview after being invited. If a publish date is set, the deadline is counted from the publish date. If the interview end time is earlier than the calculated candidate deadline, the end time is used instead.',
      candidateAnswerTimeDaysTooltipWithoutPublishTime: 'Set the number of days each candidate has to complete the interview after being invited. If the interview end time is earlier than the calculated candidate deadline, the end time is used instead.',
      candidateAnswerTimeDaysPlaceholder: 'Days to submit answers not set',
      candidateAnswerTimeDaysInvalid: 'The value must be at least 1',
      unsetCandidateAnswerTimeDays: 'Unset',
      saveCandidateAnswerTimeDays: 'Save',
      timezone: 'Time zone',
      isNotPastDate: 'date is in the past.',
      interviewIsClosed: 'The interview is currently closed. do you want to ',
      interviewIsClosedLink: 'open it',
      edit: {
        details: 'Edit interview',
        status: 'Change interview status',
        team: 'Edit team',
      },
      questions: 'Interview questions',
      answerable: 'Question can be answered',
      required: 'Answer is required',
      questionsDescription:
        'These are the questions participants are asked to answer.',
      questionsNotEditable:
        'Questions cannot be edited after invitations are sent.',
      saved: 'Interview saved',
      deleted: 'Interview deleted',
      delete: 'Delete interview',
      cancel: 'Cancel',
      save: 'Save',
      language: 'Interview language',
      languagePlaceholder: 'Choose',
      confirmLeave: 'You have unsaved changes. Are you sure you want to leave?',
      OnboardingHeadImageSize:
        'Recommended head banner image size is 1440px*320px or higher.',
      answerTimeLabel: 'Answer time',
      preparationTimeLabel: 'Preparation time',
      takeLimitLabel: 'Number of takes',
      confirmHeader: 'Are you sure you want to delete this interview?',
      integratedConfirmContent:
        'This interview is integrated to another system and removing it may cause issues with the integration.',
      evaluationCriteriaLabel: 'Evaluation criteria',
    },

    interview: {
      endTime: date => (date ? `until ${date}` : ''),
      edit: 'Edit interview',
      copy: 'Copy interview',
      editInvitation: 'Edit invitation message',
      editTeam: 'Edit team',
      editMenu: 'Edit',
      questions: 'Interview questions',
      changeStatus: 'Change interview status',
      publishSettings: 'Publishing settings',
      invite: 'Invite candidates',
      showCandidates: 'Show candidates',
      oneError: ' Embedded interview can only have one question.',
      copySuccess: 'The interview was copied successfully',
      editIntroduceBatches: 'Edit introductions',
      editEmailSettings: 'Edit email settings',
    },

    interviews: {
      allInterviews: 'All video interviews',
      createNewVideoInterview: 'Create new video interview',
      filter: 'Search interviews',
      invites: 'Invites',
      responses: 'Responses',
      sort: {
        title: 'Title',
        endTime: 'End date',
        publishTime: 'Publish date',
        createdAt: 'Creation date',
        updatedAt: 'Last modified',
        answeredCount: 'Candidates',
      },
    },

    interviewCandidates: {
      preview: 'Preview',
      endTime: date => (date ? `Open until ${date}` : ''),
      publicTitle: 'Public interview',
      embedTitle: 'Embedded interview',
      placeholder: {
        first: 'No candidates yet.',
        second: 'You can also make your video interview public.',
        third:
          'Then everyone intererested in the position are able to see the interview and apply for it.',
        fourth:
          "Don't forget that all of these are only one button away in the title bar above.",
      },
      title: 'All candidates',
      sort: {
        default: 'Default',
        updatedAt: 'Last modified',
        name: 'Name',
        rating: 'Rating',
        createdAt: 'Creation date',
      },
      sendMessage: 'Send message',
      changeStage: 'Move to another stage',
      introduce: 'Introduce',
      filter: 'Search candidates',
      hideFilters: 'Hide filters',
      showFilters: 'Show filters',
      emailSent: 'Email sent!',
      interviewClosedError:
        'You cannot reinvite a candidate to a video interview that is closed.',
      excel: 'Export all candidates',
      reInviteSent: candidates => `${candidates} reinvites sent!`,
    },

    jobAdEdit: {
      preview: 'Preview',
      confirm: 'Are you sure you want to add this job?',
      deleteHeader: 'Are you sure you want to delete this job?',
      deleteContent:
        'Deleting this job also removes all information related to the job position such as applications and video interviews.',
      titlePlaceholder: 'Title of the job',
      locationPlaceholder: 'Location',
      endTimePlaceholder: 'Open until',
      endTimeTooltip:
        'Select a date when the application period ends. Job ad will be closed automatically.',
      isNotPastDate: 'date is in the past.',
      publishTimePlaceholder: 'Publish date',
      publishTimeTooltip:
        'Set a publish date for the job ad. You can change the date anytime you want.',
      timezone: 'Time zone',
      language: 'Language',
      languagePlaceholder: 'Choose',
      description: 'Job description',
      saved: 'Job saved',
      deleted: 'Job deleted',
      descriptionPlaceholder:
        'Write your job description here. \n\nYou can enrich the description with text modification tools above.',
      createInviteOnly: 'Create invite only video interview',
      delete: 'Delete job',
      cancel: 'Cancel',
      save: 'Save',
      confirmLeave: 'You have unsaved changes. Are you sure you want to leave?',
      singleHireEndError: "Single hire can't be used more than 60 days.",
      OnboardingHeadImageSize:
        'Recommended head banner image size is 1440px*320px or higher.',
    },

    jobAdApplications: {
      endTime: date => (date ? `, open until ${date}` : ''),
      title: 'All applications',
      sort: {
        updatedAt: 'Last modified',
        name: 'Name',
        rating: 'Rating',
        createdAt: 'Creation date',
      },
      add: 'Add new candidate',
      inviteToInterview: 'Invite',
      sendMessage: 'Send message',
      changeStage: 'Move to another stage',
      introduce: 'Introduce',
      editIntroduceBatches: 'Edit introductions',
      filter: 'Search applications',
      hideFilters: 'Hide filters',
      showFilters: 'Show filters',
      addInterviewConfirm: jobAd =>
        `Do you want to create a new video interview attached to the job "${jobAd}" ?`,
    },

    adminJobAdApplication: {
      name: 'Name',
      city: 'Hometown',
      email: 'Email',
      phone: 'Phone Number',
      back: 'Back',
      continue: 'Continue',
      submit: 'Add',
      namePlaceholder: 'Candidate name',
      emailPlaceholder: 'Candidate Email',
      cityPlaceholder: "Candidate's current hometown",
      links: 'Add links, for example LinkedIn profile',
      legendBasicInfo: 'Basic information',
      legendLinks: 'Links',
      legendAttachments: 'Attachments',
      legendAdditionalFields: 'Additional information',
      coverLetter: 'Cover letter',
      attachments: 'Attachments',
      introduction: 'Write short introduction here',
      readyInfo: 'Thank you. Candidate has now been added to the job position.',
      close: 'Close',
      excel: 'Export all applications',
    },

    jobAdPreview: {
      endTime: date => (date ? `, open until ${date}` : ''),
      exit: 'Exit preview',
      description: 'Job description',
      video: 'Employer video',
      questions: 'Video question',
      apply: 'Apply position',
    },

    jobAd: {
      endTime: date => (date ? `, open until ${date}` : ''),
      changeStatus: 'Change job status',
      edit: 'Edit job',
      copy: 'Copy job',
      editInvitation: 'Edit invitation message',
      editTeam: 'Edit team',
      editMenu: 'Edit',
      description: 'Job description',
      video: 'Employer video',
      questions: 'Video question',
      apply: 'Apply position',
      showApplications: 'Show applications',
      publicLink: "Job ad's public page",
      copySuccess: 'The job was copied successfully',
    },

    jobAds: {
      subscriptionNeeded:
        'You need an active subscription to publish this job position.',
      responses: 'Applications',
      createNewJobPosition: 'Create new job position',
      allJobPositions: 'All job positions',
      confirmSingleHire:
        'One of your purchased single hires are used for this job position.',
      filter: 'Search job positions',
      sort: {
        title: 'Title',
        publishTime: 'Publish date',
        applicationCount: 'Applications',
        endTime: 'End date',
        createdAt: 'Creation date',
        updatedAt: 'Last modified',
      },
    },

    jobAdSaved: {
      title: 'Job position saved!',
      description:
        'Your job ad is now saved. Here is a public link to the job ad:',
      addApplication: 'Direct link to the application form:',
      toDashboard: 'Front page',
      toJobAd: 'Back to job ad',
    },

    interviewGuides: {
      allGuides: 'All interview guide templates',
      createNewGuide: 'Create new interview guide template',
      noResults: 'No interview guide templates found.',
      sort: {
        title: 'Title',
        createdAt: 'Creation date',
      },
    },

    interviewGuide: {
      headerTitle: 'Interview guide',
      titleLabel: 'Interview guide title',
      editTitle: 'Edit interview guide',
      titlePlaceholder: 'Enter interview guide title',
      languageLabel: 'Interview guide language',
      descriptionLabel: 'Description',
      descriptionPlaceholder:
        'Describe the purpose of the interview guide.',
      noDescription: 'No description provided.',
      saved: 'Interview guide saved',
      stepsLabel: 'Interview guide sections',
      stepsSubtitle: 'Define the sections of the interview.',
      deleted: 'Interview guide deleted',
      delete: 'Delete interview guide',
      cancel: 'Cancel',
      save: 'Save interview guide',
      ownerLabel: 'Owner',
      evaluationScale: 'Evaluation scale',
      confirmLeave:
        'You have unsaved changes. Are you sure you want to leave this page?',
      confirmHeader: 'Are you sure you want to delete this interview guide?',
    },

    interviewRounds: {
      allRounds: 'All interview rounds',
      createNewRound: 'Create new interview round',
      noResults: 'No interview rounds found.',
      total: (count) => `${count} interview rounds`,
      sort: {
        title: 'Title',
        createdAt: 'Creation date',
        updatedAt: 'Last modified',
        endTime: 'Open until',
        owner: 'Owner',
      },
    },

    interviewRound: {
      languageAndGuideInfoTextTitle:
        'The interviews belonging to this round will all use the interview guide and language you select here.',
      languageAndGuideInfoText:
        "The language and the guide cannot currently be edited per interview. The interview round's guide and language cannot be edited after you have invited candidates to this round.",
      selectedCandidatesInfoText:
        'Some of the selected candidates have already been invited. If you want to reschedule, open the candidate page.',
      closedWarningText: 'Interview round status is currently "closed". Do you want to ',
      closedLinkText: 'change it to "open"?',
      addCandidatesTitle: 'Add candidates',
      candidatesAdded: (count) => `${count} candidates added to the interview round.`,
      existingCandidates: (count) => `${count} candidates were already in the interview round.`,
      scheduleInterview: 'Schedule interview',
      headerTitle: 'Interview round',
      titleLabel: 'Interview round title',
      languageLabel: 'Interview round language',
      endTimeLabel: 'Open until',
      timezoneLabel: 'Time zone',
      editTitle: 'Edit interview round',
      titlePlaceholder: 'Enter interview round title',
      interviewGuideLabel: details => details
        ? 'Interview guide'
        : 'Select interview guide template for the interview',
      noGuide: 'No interview guide template selected',
      noGuidesForLanguage: 'No interview guides available for the selected language',
      saved: 'Interview round saved',
      deleted: 'Interview round deleted',
      delete: 'Delete interview round',
      candidatesInvited: 'Candidates invited.',
      cancel: 'Cancel',
      save: 'Save interview round',
      ownerLabel: 'Owner',
      confirmLeave:
        'You have unsaved changes. Are you sure you want to leave this page?',
      confirmHeader: 'Are you sure you want to delete this interview round?',
      removeGuide: 'Clear guide',
      noCandidates: 'No interviews yet.',
      changeStatus: 'Change interview round status',
      sort: {
        updatedAt: 'Last modified',
        startTime: 'Start time of the interview',
        name: 'Name',
        lastAccess: 'Last access',
        createdAt: 'Creation date',
      },
    },

    interviewInsights: {
      header: 'Interview Insights',
      statisticalAnalysis: 'Statistical analysis',
      overallFeedback: 'Overall feedback',
      detailedFeedback: 'Detailed feedback',
      compliance: 'Compliance',
      complianceIssue: 'Compliance issue',
      close: 'Close',
      speakingTime: 'Speaking time',
      candidate: 'Candidate',
      interviewer: 'Interviewer',
      interviewersMultiple: 'Interviewers',
      adherence: {
        timeTable: 'Adherence to time table',
        sections: 'Adherence to section times',
        questions: 'Adherence to questions',
        talkRatio: 'Speaking time distribution',
      },
      readMore: 'Read more',
      analysis: 'Analysis',
      sections: 'Sections',
      details: 'Detailed feedback',
      proposedNextSteps: 'Proposed next steps',
      analysisInProgress: 'Insights analysis in progress...',
      analysisFailed: 'Error loading insights analysis.',
      tryAgainLater: 'Please try again later.',
      legalContext: 'Legal context',
    },

    live: {
      interviewersInfo:
        'When you add interviewers who are not in the interview round admins, they will be added as admins to the interview round.',
      noStartTimeSelected: 'No start time selected',
      noInterviewers: 'No interviewers',
      title: 'Live interview',
      editTitle: 'Edit live interview',
      startTimeTitle: 'Interview start time',
      startTime: 'Start time',
      notScheduled: 'Not scheduled',
      interviewers: 'Interviewers',
      candidate: 'Candidate',
      candidates: 'Candidates',
      candidateDisplayName: `Candidate's name`,
      messageLabel: 'Invitation message',
      languageLabel: 'Language',
      create: 'Create',
      save: 'Save changes',
      cancel: 'Cancel',
      reschedule: 'Reschedule interview',
      schedule: 'Schedule interview',
      removeLive: 'Remove live interview',
      cancelLive: 'Cancel live interview',
      evaluationLabel: 'Evaluation',
      evaluationComparisonLabel: 'Evaluation comparison',
      comment: 'Add a new comment',
      commentLabel: 'Comments',
      interviewInsights: 'Interview Insights',
      continueEvaluation: 'Continue evaluation',
      viewRecordings: 'View interview recordings',
      transcriptButtonText: 'Interview transcript',
      interviewGuideLabel: details => details
        ? 'Interview guide'
        : 'Select interview guide template for the interview',
      noGuide: 'No interview guide template selected',
      interviewGuideInfo:
        'You can only use a interview guide when there is one candidate.',
      enter: 'Enter live interview',
      edit: 'Edit interview',
      draft: 'New live interview',
      pending: 'Waiting for candidate confirmation',
      scheduledLiveCandidateSubtitle:
        'For the scheduled live interview you can only add one candidate.',
      confirmHeader: 'Are you sure you want to delete this live interview?',
      inviteFailure: (success, failed) =>
        `${success} invitations sent and ${failed} failed!`,
      inviteSuccess: success => `${success} invitations sent.`,
      recordingsHeaderWithTitle: title =>
        `Recordings for live interview ${title}`,
      recordingsHeader: `Live interview recordings`,
      success: {
        create: 'New live interview created',
        delete: 'Live interview removed',
        update: 'Live interview updated',
      },
      placeholders: {
        candidateEmails: 'Add candidate',
        interviewerEmails: 'Add interviewer',
        emailTitle: 'Title',
        emailMessage: 'Message',
        emailName: 'Name',
      },
      successInviteSent: 'Interview time selection message sent to candidate.',
      errorInviteNotSent: 'Message could not be sent.',
      startTimeChanged: 'The start time of the interview has been changed.',
      rescheduleConfirmBody: 'Are you sure you want to reschedule this interview?',
      backToRound: 'Back to interview round',
      schedulingInfo:
        "You can use the interview's organisation's users' calendars that are connected to Recright and are interviewers in this interview.",
    },

    lives: {
      allLives: 'All live interviews',
      createNewLive: 'Create new live interview',
      filter: 'Search by candidates',
      candidates: 'Candidates',
      sort: {
        title: 'Title',
        startTime: 'Start time',
        createdAt: 'Creation date',
      },
    },

    login: {
      title: 'Log in to the service',
      register: 'Register',
      forgot: 'Forgot password?',
      normal: 'Normal log in',
      ssoLogin: 'SSO login',
    },

    quickInterview: {
      title: 'Quick video interview',
      description:
        'To get to know you faster we would like you to briefly answer to our quick interview question. Bring in your personality and give your application a soul.',
      requiredNote:
        'Note that this is one part of the application process, and recruiter will receive your application only after you have recorded your answer.',
      reminderNote:
        'You can record the answer right away, or you can continue later by receiving a reminder to your email.',
    },

    register: {
      title: 'Designed for recruiters!',
      leadText:
        'Recright is an easy-to-use video recruitment platform for recruiters and hiring managers. You can publish open positions, receive applications and conduct video interviews - all in one place! Our tool has helped over 400 companies find the right people, and your company could be the next one! Sign up below and start recruiting!',
      email: 'Email',
      submit: 'Sign up',
      alreadyMember: 'Already a member?',
      onlyForRecruiters: 'This sign up is for recruiters and hiring managers.',
      login: 'Login here.',
      registerSuccess:
        'Check your email and register through the link we sent you.',
      domainError: 'Please register with your company email address.',
      companyExistsMessage: 'Check your email for instructions!',
    },

    searchResults: {
      title: 'Search results',
      applications: 'Applications',
      candidates: 'Candidates',
      noApplications: 'No applications matching search criteria',
      noCandidates: 'No candidates matching search criteria',
      query: query => (query ? `Search query: ${query}` : ''),
      noStage: 'Not in any stage yet',
      search: 'Search',
      itemsPerPage: 'Items per page',
    },

    statistics: {
      linkToDetailed: 'See detailed statistics',
      linkToSummary: 'See statistics summary',
      summaryLeadText:
        'Figures below comprises of all active positions during the selected time period including the positions that do not have an end date.',
      detailsLeadText:
        'This page provides detailed statistics on all positions with any activity during the selected time period.',
      export: 'Export statistics',
      sort: {
        title: 'Title',
        owner: 'Owner',
        createdAt: 'Creation date',
      },
      exportLimit:
        'Too many results. Please reduce the timeframe to enable excel export.',
      tooManyResults:
        'Too many results. Please reduce the timeframe to get results.',
    },

    welcome: {
      title: 'Sign up',
    },

    welcomeMulticompany: {
      welcome: companyName => `Welcome to ${companyName}`,
      successMessage: companyName =>
        `You have now been added to the organisation ${companyName}!`,
      navigationInfo:
        'You can change your current organisation from the navigation bar on the top right.',
      login: 'Login here',
    },

    forgotPassword: {
      title: 'Setting a new password',
      email: 'Email',
      submit: 'Send',
      sendEmail:
        'Send us the email address you used to register into Recright.',
      instructions:
        'We will send you instructions on how to change your password.',
      success:
        'If user was found with the email address provided, The instructions for changing your password have been sent to that address.',
    },

    changePassword: {
      title: 'Change password',
      name: 'Name',
      email: 'Email',
      password: 'New password',
      confirmPassword: 'Confirm new password',
      submit: 'Change password',
      error: {
        password: {
          isRequired: 'Password is required. ',
          isValidPassword: 'A valid password must be minimum of 12 characters including at least one uppercase letter, one lowercase letter and one number.',
          passwordsMatch: 'Passwords do not match. ',
        },
      },
    },

    ssoLogin: {
      title: 'SSO login',
      description: "Log in with your organisation's credentials",
      info: 'External authentication not configured. Please use the',
      normalLoginLinkText: 'normal login.',
      submit: 'Log in to the service',
    },

    subscribe: {
      title: 'Subscribe',
      submit: 'Subscribe',
      creditCard: 'Credit card',
      cvv: 'CVV',
      expirationDate: 'Expiration date',
      vatAdvice:
        'By providing VAT ID, we will not charge you value added taxes.',
      vatId: 'VAT / Tax ID',
      vatHelp:
        'Provide your VAT ID in international format including the country code.',
      includeVat: 'incl. VAT',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      company: 'Company',
      street: 'Street',
      postalCode: 'Postal code',
      city: 'City',
      country: 'Country',
      emptyCardFields: 'Please fill your credit card details',
      invalidValue: 'Field value is invalid.',
      planNotSelected: 'Please select plan',
      totalPrice: 'Total',
      subscribed: 'Awesome! Your subscription is created.',
      subscriptionExists:
        'Your company seem to have an active subscription. Please login to change your subscription.',
      agreeTos: 'I have read and approve ',
      agreeTosLinkText: 'the Recright User Terms and Conditions.',
      privacyPolicy: 'We value your privacy, please read our ',
      licenseAgreement: 'On behalf of the organisation I represent I accept ',
      licenseAgreementLinkText: "Recright's General Terms of Service.",
      privacyPolicyLinkText: 'Privacy Policy.',
      newsletter: 'Subscribe to monthly newsletter.',
      neverExpiresDiscount: amount =>
        `Including lifetime discount ${amount} EUR`,
      fixedPeriodDiscount: (amount, cycles) =>
        `Including discount ${amount} EUR for ${cycles} months`,
      errorFromProcessor: error =>
        `Payment processor responded with error: ${error}`,
    },

    videos: {
      title: 'Video library',
      add: 'Create new video',
      rename: 'Rename',
      remove: 'Remove',
      yourVideos: 'Your videos',
      companyVideos: 'Company videos',
      confirmDeleteVideoTitle:
        'Are you sure you want to permanently delete this video?',
      confirmDeleteVideoMessage:
        'This will remove the video from the library and all Collections.',
      addToCollection: 'Add to collection',
    },

    userManagement: {
      excel: 'Export all users',
      title: 'User management',
      showCompanyDefaultPermissions: 'Show company default permissions',
      activateUserConfirm: 'Are you sure you want to activate this user?',
      deactivateUserConfirm: 'Are you sure you want to deactivate this user?',
      showActivatedUsers: 'Show active users',
      showDeactivatedUsers: 'Show deactivated users',
      confirmCancelEditPermissions: {
        message:
          'You have unsaved changes. Are you sure you want to discard all changes?',
        cancel: 'Cancel',
        confirm: 'Discard changes',
      },
      unsavedChanges:
        'You have unsaved changes. Do you want to save these changes?',
      confirm: 'Save',
      permissionsChangesSaved: 'Users permissions changed succesfully!',
      userDeactivated: nameOrEmail => `${nameOrEmail} deactivated`,
      userActivated: nameOrEmail => `${nameOrEmail} activated`,
      companyDefaultsSaved: 'Default admin permissions changed succesfully!',
      usersAddAdded: success => `${success} users added.`,
      usersAddExist: exist => ` ${exist} users are already in Recright.`,
      excel: 'Export all users',
    },
  },
}
